import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import { trackEvent as track } from '../../utils/analytics';
type Bi = {
  fr: string;
  en: string;
};
const copy = {
  headline: [{
    text: {
      fr: 'Et si vos équipes pouvaient',
      en: 'What if your teams could'
    },
    accent: false
  }, {
    text: {
      fr: 'en faire plus,',
      en: 'do more,'
    },
    accent: false
  }, {
    text: {
      fr: 'sans en faire plus ?',
      en: 'without doing more?'
    },
    accent: true
  }],
  body: {
    fr: 'Voyez ce qu’ATNA pourrait prendre en charge dans votre organisation.',
    en: 'See what ATNA could take on in your organization.'
  },
  cta: {
    fr: 'Demander une démo',
    en: 'Request a demo'
  },
  signature: {
    fr: 'Comprendre. Vérifier. Recommander. Orchestrer. Agir.',
    en: 'Understand. Verify. Recommend. Orchestrate. Act.'
  }
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function AtnaClosing() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section className="relative overflow-hidden bg-[#FDFDFF] px-6 py-28 md:py-36 lg:py-44" aria-labelledby="atna-closing-title" data-id="element-802" data-mp="1e9fbju9ydx1o">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] max-w-[140%] h-[520px] rounded-full bg-[#EEEDFD] opacity-60 blur-[160px]" aria-hidden="true" data-id="element-803" data-mp="1s7wvri0ngreu" />

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative max-w-[900px] mx-auto text-center" data-id="element-804" data-mp="zhet2i3u8s1y">
        <span className="block w-10 h-px bg-[#4F46E5] mx-auto mb-10" aria-hidden="true" data-id="element-805" data-mp="14hjd2i3yg4wx" />

        <h2 id="atna-closing-title" className="font-serif text-[2.2rem] sm:text-[2.8rem] lg:text-[3.4rem] leading-[1.04] tracking-tight" data-id="element-806" data-mp="grp0m1njsid7">
          {copy.headline.map(l => <span key={l.text.fr} className={`block ${l.accent ? 'text-[#4F46E5]' : 'text-[#121A3A]'}`} data-id="element-807" data-mp="2bvdbjt6yw79a">
              {pick(l.text)}
            </span>)}
        </h2>

        <p className="mt-8 font-sans text-[15.5px] md:text-[17px] text-[#4A5268] leading-relaxed" data-id="element-808" data-mp="2llpszcjhjkb7">{pick(copy.body)}</p>

        <Link to="/request-demo" onClick={() => track('Demo CTA Clicked', {
        location: 'ATNA Closing CTA'
      })} className="mt-9 inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-xl bg-[#4F46E5] px-12 py-4 font-sans text-[16px] font-medium text-white shadow-[0_14px_30px_-14px_rgba(79,70,229,0.7)] hover:bg-[#4338CA] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F46E5] focus-visible:ring-offset-2" data-id="element-809" data-mp="2pmrtdwp522er">
          {pick(copy.cta)}
          <ArrowRightIcon className="w-4 h-4" strokeWidth={2} aria-hidden="true" data-id="element-810" data-mp="3dd5qi1mkyrg7" />
        </Link>

        <p className="mt-14 md:mt-16 font-sans text-[12px] md:text-[13px] font-medium tracking-[0.22em] uppercase text-[#8A8FB8]" data-id="element-811" data-mp="3ianpaz6vvqah">
          {pick(copy.signature)}
        </p>
      </motion.div>
    </section>;
}